module.exports = __webpack_public_path__ + "static/media/textRenderingApi.00e9c3a0.md";